module.exports = __webpack_public_path__ + "static/media/question.7926e1e9.svg";